<template>
  <div class="snow-checkbox" :class="[componentClasses, { indeterminate }]">
    <b-form-checkbox
      v-model="innerValue"
      :id="'checkbox-' + id"
      :name="String(id)"
      :value="id"
      :unchecked-value="uncheckedValue"
      :indeterminate="indeterminate"
      :disabled="disabled"
      @change="v => $emit('change', v, id)"
    >
      <slot>
        <div class="d-flex align-items-center ml-3 gap-3">
          <span :class="[{ 'fs-14': size == 'sm' }]">
            {{ name }}
            <span v-if="required" class="text-negative-700">*</span>
          </span>
          <bp-tooltip :text="warning" v-if="warning">
            <i class="text-negative-500 fa fa-circle-exclamation fs-12" />
          </bp-tooltip>
        </div>
      </slot>
    </b-form-checkbox>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    id: {
      type: [String, Number],
      required: true
    },
    name: {
      type: [String, Number],
      default: ""
    },
    uncheckedValue: {
      type: String,
      default: ""
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "lg",
      validation: v => ["sm", "lg"].includes(v)
    },
    required: {
      type: Boolean,
      default: false
    },
    warning: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  computed: {
    componentClasses() {
      const componentClasses = [this.size];

      return componentClasses;
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      if (newVal !== this.value) this.$emit("input", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-checkbox {
  position: relative;

  ::v-deep {
    .custom-control.custom-checkbox {
      position: unset;
      display: flex;
      align-items: center;
      padding-left: 24px;

      .custom-control-input {
        top: 3px;
        left: 6px;
        width: 18px;
        height: 18px;
        @media screen and (max-width: 667px) {
          top: 2px;
          width: 20px;
          height: 20px;
        }
      }

      .custom-control-label {
        display: flex;
        min-height: 24px;
        align-items: center;

        &::before {
          box-shadow: unset;
          border-radius: 5px;
          border: 1px solid #929292;
        }
        &::before,
        &::after {
          top: 3px;
          left: -18px;
          width: 18px;
          height: 18px;
          @media screen and (max-width: 667px) {
            top: 2px;
            width: 20px;
            height: 20px;
          }
        }
      }
      &:has(input:checked) {
        .custom-control-label {
          &::before {
            background-color: black;
            border-color: black;
          }
        }
      }
    }
    .custom-checkbox
      .custom-control-input:indeterminate
      ~ .custom-control-label::before {
      background-color: black;
      border-color: black;
    }
  }
  &.lg {
    ::v-deep {
      .custom-control.custom-checkbox {
        .custom-control-label {
          &::before,
          &::after {
            @media screen and (max-width: 667px) {
              top: 3px;
            }
          }
        }
        .custom-control-input {
          @media screen and (max-width: 667px) {
            top: 3px;
          }
        }
      }
    }
  }
}
</style>
